import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  /** 'light' = texto branco para fundos escuros (heroes com overlay)
   *  'dark'  = texto cinza para fundos claros */
  variant?: 'light' | 'dark';
  className?: string;
}

/**
 * Breadcrumb visual reutilizável.
 * O Schema.org BreadcrumbList é responsabilidade do useEffect de cada página.
 */
export default function Breadcrumb({ items, variant = 'dark', className = '' }: BreadcrumbProps) {
  const linkCls =
    variant === 'light'
      ? 'text-white/65 hover:text-white transition-colors'
      : 'text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors';

  const separatorCls =
    variant === 'light'
      ? 'text-white/35'
      : 'text-gray-300 dark:text-gray-600';

  const currentCls = 'text-primary font-semibold';

  return (
    <nav aria-label="Breadcrumb" className={`flex items-center flex-wrap gap-y-1 text-sm font-body ${className}`}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <div className={`w-4 h-4 flex items-center justify-center flex-shrink-0 ${separatorCls}`}>
                <i className="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
              </div>
            )}

            {isLast ? (
              <span aria-current="page" className={currentCls}>
                {item.label}
              </span>
            ) : (
              <Link
                to={item.to ?? '/'}
                className={`flex items-center gap-1 cursor-pointer whitespace-nowrap ${linkCls}`}
              >
                {index === 0 && (
                  <div className="w-3.5 h-3.5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-home-4-line text-xs" aria-hidden="true"></i>
                  </div>
                )}
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
